<script>
  import {BODY_TYPES}         from '../../../../constants/bodies-by-type';
  import {bodyTypeFlagsStore} from '../../../../stores/filters/body-type-flags-store';
  import HelpButton           from '../../../help-button/help-button.svelte';

  const helps = {
    bodyTypes: {
      topic: 'Body Types',
      description: 'Karts, Standard Bikes and ATVs drift outward when turning, while Sport Bikes turn more sharply inward. Try both styles to see which you prefer!'
    }
  };

  const bodyTypeClass = (bodyType) => {
    const type = bodyType.toLowerCase().replace(' ', '-');
    return `body-type-${type}`;
  };
</script>

<style>
  .body-type-atvs           { background-image: url('img/bodies/Standard ATV (Standard Quad).png'); }
  .body-type-karts          { background-image: url('img/bodies/Standard Kart.png'); }
  .body-type-sport-bikes    { background-image: url('img/bodies/Sport Bike.png'); }
  .body-type-standard-bikes { background-image: url('img/bodies/Standard Bike.png'); }

  .body-type-filter label {
    padding-right: 50px;
  }
</style>

<template lang="pug" src="./body-type-filter.pug"></template>
